import overviewPoster from './posters/overview.jpg';
import rewritePoster from './posters/rewrite.jpg';
import tonesPoster from './posters/tones.jpg';
import instructionsPoster from './posters/instructions.jpg';
import toolsPoster from './posters/tools.jpg';
import dictationPoster from './posters/dictation.jpg';
import imageTextPoster from './posters/image-text.jpg';
import overviewCaptions from './captions/overview.vtt?url';
import rewriteCaptions from './captions/rewrite.vtt?url';
import tonesCaptions from './captions/tones.vtt?url';
import instructionsCaptions from './captions/instructions.vtt?url';
import toolsCaptions from './captions/tools.vtt?url';
import dictationCaptions from './captions/dictation.vtt?url';
import imageTextCaptions from './captions/image-text.vtt?url';

export const OVERVIEW = {
  src: '/media/lyrmo-promo_v48-studio-overview.mp4',
  poster: overviewPoster,
  captions: overviewCaptions,
  duration: 115.73,
};

/** Each demo is a complete film, independent of the Studio overview. */
export const FEATURE_PROMOS = [
  {
    id: 'rewrite',
    src: '/media/lyrmo-promo_v49-rewrite-narrated.mp4',
    poster: rewritePoster,
    captions: rewriteCaptions,
    duration: 63.4,
  },
  {
    id: 'tones',
    src: '/media/lyrmo-promo_v38-tones-narrated.mp4',
    poster: tonesPoster,
    captions: tonesCaptions,
    duration: 47.5,
  },
  {
    id: 'instructions',
    src: '/media/lyrmo-promo_v37-instructions-narrated.mp4',
    poster: instructionsPoster,
    captions: instructionsCaptions,
    duration: 57,
  },
  {
    id: 'tools',
    src: '/media/lyrmo-promo_v36-ai-tools-narrated.mp4',
    poster: toolsPoster,
    captions: toolsCaptions,
    duration: 59,
  },
  {
    id: 'dictation',
    src: '/media/lyrmo-promo_v40-dictation-noise-narrated.mp4',
    poster: dictationPoster,
    captions: dictationCaptions,
    duration: 53.9,
  },
  {
    id: 'image-text',
    src: '/media/lyrmo-promo_v52-image-text-describe-narrated.mp4',
    poster: imageTextPoster,
    captions: imageTextCaptions,
    duration: 50.4,
  },
] as const;

export const clock = (seconds: number): string =>
  `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;

export type FeatureId = (typeof FEATURE_PROMOS)[number]['id'];
export type FeaturePromo = (typeof FEATURE_PROMOS)[number];
